(function () {
  "use strict";

  var HOME_PATHS = /^\/(?:zh-hant|zh-hans|ja|vi|th|de|ko|es)?\/?$/;

  function isProbablyHome() {
    return HOME_PATHS.test(window.location.pathname);
  }

  function textFromHref(href) {
    if (!href || href === "#" || href === "#none") return "";
    if (href.indexOf("/cart") !== -1) return "Cart";
    if (href.indexOf("/search") !== -1) return "Search";
    if (href === "/" || /\/(?:zh-hant|zh-hans|ja|vi|th|de|ko|es)\/?$/.test(href)) {
      return "Warmcore Tech home";
    }
    var clean = href.split("?")[0].split("#")[0].replace(/\/$/, "");
    var slug = clean.split("/").pop() || "";
    return slug.replace(/[-_]+/g, " ").trim();
  }

  function hasAccessibleName(link) {
    return Boolean(
      (link.textContent || "").trim() ||
      link.getAttribute("aria-label") ||
      link.getAttribute("title") ||
      link.querySelector("img[alt]:not([alt=''])")
    );
  }

  function repairEmptyLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      if (hasAccessibleName(link)) return;

      var img = link.querySelector("img[alt]:not([alt=''])");
      var label = img ? img.getAttribute("alt") : textFromHref(link.getAttribute("href"));

      if (!label && link.matches("[data-menu-drawer], .bee-push-menu-btn")) label = "Open menu";
      if (!label && /logo|brand/i.test(link.className)) label = "Warmcore Tech home";
      if (!label) label = "Open linked content";

      link.setAttribute("aria-label", label);
    });
  }

  function setImageAttributes(img) {
    var rect = img.getBoundingClientRect();
    var isAboveFold = rect.top < window.innerHeight + 120;

    if (!isAboveFold && !img.hasAttribute("loading")) {
      img.setAttribute("loading", "lazy");
    }

    if (!img.hasAttribute("decoding")) {
      img.setAttribute("decoding", isAboveFold ? "sync" : "async");
    }

    if (!isAboveFold && !img.hasAttribute("fetchpriority")) {
      img.setAttribute("fetchpriority", "low");
    }

    if ((!img.hasAttribute("width") || !img.hasAttribute("height")) && img.naturalWidth && img.naturalHeight) {
      img.setAttribute("width", String(img.naturalWidth));
      img.setAttribute("height", String(img.naturalHeight));
    }
  }

  function repairImages() {
    document.querySelectorAll("img").forEach(function (img) {
      setImageAttributes(img);
      if (!img.complete) {
        img.addEventListener("load", function () {
          setImageAttributes(img);
        }, { once: true });
      }
    });
  }

  function loadDeferredVideo(container) {
    if (container.classList.contains("is-loaded")) return;

    var src = container.getAttribute("data-wc-video-src");
    if (!src) return;

    var video = document.createElement("video");
    video.className = "wc-deferred-video__player";
    video.controls = container.getAttribute("data-wc-controls") !== "false";
    video.playsInline = true;
    video.preload = "metadata";

    if (container.getAttribute("data-wc-muted") === "true") video.muted = true;
    if (container.getAttribute("data-wc-loop") === "true") video.loop = true;
    if (container.getAttribute("data-wc-autoplay") === "true") video.autoplay = true;

    var source = document.createElement("source");
    source.src = src;
    source.type = container.getAttribute("data-wc-video-type") || "video/mp4";
    video.appendChild(source);

    container.appendChild(video);
    container.classList.add("is-loaded");
    video.play().catch(function () {});
  }

  function initDeferredVideos() {
    document.querySelectorAll("[data-wc-video-src]").forEach(function (container) {
      var mode = container.getAttribute("data-wc-load") || "click";
      var button = container.querySelector(".wc-deferred-video__button");

      if (button) {
        button.addEventListener("click", function () {
          loadDeferredVideo(container);
        });
      }

      if (mode === "visible" && "IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            loadDeferredVideo(container);
            observer.disconnect();
          });
        }, { rootMargin: "300px 0px" });
        observer.observe(container);
      }
    });
  }

  function getHeroVideoSrc(hero) {
    var isMobile = window.matchMedia("(max-width: 767px)").matches;
    return isMobile
      ? hero.getAttribute("data-hero-video-mobile-src") || hero.getAttribute("data-hero-video-src")
      : hero.getAttribute("data-hero-video-desktop-src") || hero.getAttribute("data-hero-video-src");
  }

  function isSlowConnection() {
    var connection = navigator.connection;
    if (!connection) return false;
    return connection.saveData || /(^|-)2g$/.test(connection.effectiveType || "");
  }

  function loadHeroVideo(hero) {
    if (!hero || hero.classList.contains("is-video-loading")) return;

    var src = getHeroVideoSrc(hero);
    if (!src) return;

    hero.classList.add("is-video-loading");

    var video = document.createElement("video");
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;
    video.preload = "metadata";
    video.setAttribute("aria-hidden", "true");

    var source = document.createElement("source");
    source.src = src;
    source.type = "video/mp4";
    video.appendChild(source);

    video.addEventListener("canplay", function () {
      hero.classList.add("is-video-ready");
      video.play().catch(function () {});
    }, { once: true });

    hero.insertBefore(video, hero.firstChild);
  }

  function initHeroVideoLite() {
    var hero = document.querySelector("[data-hero-video-src], [data-hero-video-desktop-src], [data-hero-video-mobile-src]");
    if (!hero) return;

    var play = hero.querySelector(".wc-hero-video-lite__play");
    if (play) {
      play.addEventListener("click", function () {
        loadHeroVideo(hero);
      });
    }

    if (isSlowConnection()) return;

    var ageGate = document.querySelector("#ageModalBackdrop.is-active, #ageModalBackdrop");
    if (ageGate) {
      setTimeout(function () {
        loadHeroVideo(hero);
      }, 650);
      return;
    }

    window.addEventListener("load", function () {
      var start = function () {
        loadHeroVideo(hero);
      };

      if ("requestIdleCallback" in window) {
        requestIdleCallback(start, { timeout: 5000 });
      } else {
        setTimeout(start, 3500);
      }
    }, { once: true });
  }

  function compactAgeGateCopy() {
    var text = document.querySelector("#ageModalBackdrop .age-modal__text");
    if (!text || text.getAttribute("data-wc-shortened")) return;

    var lang = document.documentElement.lang || "";
    text.textContent = /zh/i.test(lang)
      ? "\u672c\u7db2\u7ad9\u542b\u4eff\u751f\u6a5f\u5668\u4eba\u8207\u4eba\u5f62\u8a2d\u8a08\u5167\u5bb9\u3002\u8acb\u78ba\u8a8d\u60a8\u5df2\u5e74\u6eff 18 \u6b72\u4e26\u540c\u610f\u9032\u5165\u3002"
      : "This site includes humanoid robotics content. Please confirm that you are 18 or older to continue.";
    text.setAttribute("data-wc-shortened", "true");
  }

  function init() {
    repairEmptyLinks();
    repairImages();
    initDeferredVideos();
    initHeroVideoLite();
    compactAgeGateCopy();

    if (!isProbablyHome()) return;
    document.documentElement.classList.add("wc-home-optimized");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
